var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIconSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.311 0.521484C2.38268 0.521484 0 2.90416 0 5.83248C0 9.40147 4.96692 13.2713 5.17855 13.434C5.21742 13.4643 5.26493 13.4787 5.311 13.4787C5.35563 13.4787 5.39882 13.4657 5.43625 13.4383C5.48808 13.4009 10.622 9.44466 10.622 5.83248C10.622 2.90416 8.23932 0.521484 5.311 0.521484ZM5.311 2.78323C6.99255 2.78323 8.36169 4.15093 8.36169 5.83248C8.36169 7.51548 6.99255 8.88318 5.311 8.88318C3.62945 8.88318 2.26031 7.51548 2.26031 5.83248C2.26031 4.15093 3.62945 2.78323 5.311 2.78323Z",
    fill: "#3C7AF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.311 7.60589C6.29003 7.60589 7.08369 6.81223 7.08369 5.8332C7.08369 4.85418 6.29003 4.06052 5.311 4.06052C4.33197 4.06052 3.53832 4.85418 3.53832 5.8332C3.53832 6.81223 4.33197 7.60589 5.311 7.60589Z",
    fill: "#3C7AF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIconSmall);
export default __webpack_public_path__ + "static/media/location-icon-small.1b96ae6258ca41e4ffaee54fe37ae4ff.svg";
export { ForwardRef as ReactComponent };